module.exports = __webpack_public_path__ + "od-chevron-slider-right/od-chevron-slider-right-b131998936f70c4fcedf321b9c8e51a7.svg";